import React from "react";
import ReactDOM from "react-dom";

function Modal({ children, onClose }) {
    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div 
            className="model-content"
            onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>,
        document.getElementById("modal-root")

    );
}

export default Modal;